import React, { useEffect, useRef, useState } from 'react';
import CommonInput from '../common/CommonInput';
import { formatReservationDate } from '../../../util/formatReservationDate';
import PopupBtmSelectArea from './PopupBtmSelectArea';
import PopupBtmBookDate from './PopupBtmBookDate';
import PopupBtmPartRepair from './PopupBtmPartRepair';

function PopupBtmResult({
    setisShowResult,
    setisCompleteResult,
    carInfo,
    setcarInfo,
    setisShowSelectArea,
    setisCompleteSelectArea,
    setisShowBookDate,
    setisCompleteBookDate,
    setisShowPartRepair,
    setisCompletePartRepair,
    setisShowAgree
}) {
  const [name, setName] = useState(carInfo.userName || '');
  const [carNumber, setCarNumber] = useState(carInfo.carNumber || '');
  const [activePopup, setActivePopup] = useState('result'); // 'result', 'area', 'date', 'part'


  // 지역 선택 팝업 열기
  const handleShowSelectArea = () => {
    setActivePopup('area');
  };

  // 예약일 선택 팝업 열기
  const handleShowBookDate = () => {
    setActivePopup('date');
  };

  // 수리부위 선택 팝업 열기
  const handleShowPartRepair = () => {
    setActivePopup('part');
  };

  const handleReturn = () => {
    setActivePopup('result');
  };


  const handleComplete = () => {
    const updatedCarInfo = {
      ...carInfo,
      userName: name,
      carNumber
    };
    setcarInfo(updatedCarInfo);
    setisShowResult(false);
    setisShowAgree(true); // 약관동의 팝업 표시
  };



  // 스와이프 관련 상태
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
    if (dragHandleRef.current?.contains(e.target)) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
    }
  };

  const onTouchMove = (e) => {
    // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
    if (touchStart) {
      setTouchEnd(e.targetTouches[0].clientY);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > minSwipeDistance;

    if (isDownSwipe) {
      setisShowResult(false);
    }
  };




  // 현재 활성화된 팝업에 따라 컴포넌트 반환
  if (activePopup === 'area') {
    return (
      <PopupBtmSelectArea
        setisShowSelectArea={handleReturn}
        setisCompleteSelectArea={setisCompleteSelectArea}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />
    );
  }

  if (activePopup === 'date') {
    return (
      <PopupBtmBookDate
        setisShowBookDate={handleReturn}
        setisCompleteBookDate={setisCompleteBookDate}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />
    );
  }

  if (activePopup === 'part') {
    return (
      <PopupBtmPartRepair
        setisShowPartRepair={handleReturn}
        setisCompletePartRepair={setisCompletePartRepair}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />
    );
  }



  if (activePopup === 'result') {

    return (
      <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
        <div
          className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative px-5"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          {/* 드래그 핸들 영역에 ref 추가 */}
          <button 
            ref={dragHandleRef}
            className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
          >
            <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
          </button>

          <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-6">
            내 접수 정보
          </h3>

          <div className="flex flex-col gap-5">
            {/* 이름 */}
            <div>
              <p className="text-[#46474C] text-[13px] mb-1">이름</p>
              <CommonInput
                inputValue={name}
                setInputValue={setName}
                placeholder="이름을 입력해주세요"
              />
            </div>

            {/* 차량번호 */}
            <div>
              <p className="text-[#46474C] text-[13px] mb-1">차량번호</p>
              <CommonInput
                inputValue={carNumber}
                setInputValue={setCarNumber}
                placeholder="차량번호를 입력해주세요"
              />
            </div>

            {/* 지역 */}
            <div>
              <p className="text-[#46474C] text-[13px] mb-1">지역</p>
              <div className="relative">
                <CommonInput
                  inputValue={carInfo.carRegion}
                  readOnly
                  placeholder="지역을 선택해주세요"
                />
                <button
                  className="absolute right-4 top-9 -translate-y-1/2 text-[15px] font-semibold text-[#313A4C]"
                  onClick={handleShowSelectArea}
                >
                  수정
                </button>
              </div>
            </div>

            {/* 예약일 */}
            <div>
              <p className="text-[#46474C] text-[13px] mb-1">예약일</p>
              <div className="relative">
                <CommonInput
                  inputValue={carInfo.carReservationDate.map(formatReservationDate).join(', ')}
                  readOnly
                  placeholder="예약일을 선택해주세요"
                />
                <button
                  className="absolute right-4 top-9 -translate-y-1/2 text-[15px] font-semibold text-[#313A4C]"
                  onClick={handleShowBookDate}
                >
                  수정
                </button>
              </div>
            </div>

            {/* 수리부위 */}
            <div>
              <p className="text-[#46474C] text-[13px] mb-1">수리부위</p>
              <div className="relative">
                <CommonInput
                  inputValue={carInfo.carRepairPart.join(', ')}
                  readOnly
                  placeholder="수리부위를 선택해주세요"
                />
                <button
                  className="absolute right-4 top-9 -translate-y-1/2 text-[15px] font-semibold text-[#313A4C]"
                  onClick={handleShowPartRepair}
                >
                  수정
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-between mt-8 gap-[10px]">
            <button
              className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold"
              onClick={() => setisShowResult(false)}
            >
              취소
            </button>
            <button
              className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#313A4C] text-white font-semibold"
              onClick={handleComplete}
            >
              완료
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default PopupBtmResult;